import { useCallback } from 'react';
import type { FormInstance } from 'ALIASED-antd';
import { useSessionAppointmentId } from '@hooks/useSessionAppointmentId';
import type { SessionForm } from '@components/Clinicians/session-form';
import ClinicianSessionFormState from './clinicianSessionFormState';

const LETTER_REVIEW_IGNORED_FIELDS = new Set<keyof SessionForm>([
  'letterViewed',
  'isLetterReadToBottom',
  'isLetterAccuracyConfirmed',
  'letterReq',
  'alert',
  'isActionsSaving',
  'isSavingNotes',
  'isSavingDataProtection',
  'isDPACheck',
  'docmanDiscussed',
  'videoCallDidStart',
  'audioCallDidStart',
  'videoCallIssues',
  'audioCallIssues',
  'networkType',
  'impact',
  'refetchInvestigationRequests',
  'filteredMedications',
  'hasPrescriptionValueBeenUpdated',
  'f2fComplete',
  'f2fReferralPosted',
  'cancellation_reason',
  'SendGDPREmail'
]);

const LETTER_REVIEW_FIELDS: (keyof SessionForm)[] = [
  'letterViewed',
  'isLetterReadToBottom',
  'isLetterAccuracyConfirmed'
];

export function useAppointmentLetterReview(form: FormInstance<SessionForm>) {
  const apptId = useSessionAppointmentId(true);

  return useCallback(
    (changedValues: Partial<Record<keyof SessionForm, unknown>>) => {
      const affectsLetter = Object.keys(changedValues).some(
        (key) => !LETTER_REVIEW_IGNORED_FIELDS.has(key as keyof SessionForm)
      );

      if (!affectsLetter) return;

      LETTER_REVIEW_FIELDS.forEach((field) => {
        form.setFieldValue(field, false);
        ClinicianSessionFormState.set(`appointment[${apptId}].${field}`, false);
      });
    },
    [form, apptId]
  );
}
